import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const TopUp = Loadable({
    loader: () => import('./TopUp'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          utilityParkingTopUpState: state.utilityParkingTopUpState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          submit,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/top-up`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <TopUp {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
